export interface HotSearchWord {
  keyword: string;
  heat: number;
  trend: "up" | "down" | "flat";
  category: string;
}

export const hotSearchCategories = ["全部", "热点", "科技", "财经", "体育", "生活", "娱乐"];

export const hotSearchWords: HotSearchWord[] = [
  { keyword: "人工智能大模型", heat: 1286000, trend: "up", category: "科技" },
  { keyword: "秋冬季旅游攻略", heat: 1164000, trend: "up", category: "生活" },
  { keyword: "前三季度经济数据", heat: 1098000, trend: "flat", category: "财经" },
  { keyword: "新能源汽车销量", heat: 986000, trend: "up", category: "财经" },
  { keyword: "全国运动会", heat: 942000, trend: "up", category: "体育" },
  { keyword: "全球气候大会", heat: 873000, trend: "flat", category: "热点" },
  { keyword: "量子计算原理", heat: 815000, trend: "up", category: "科技" },
  { keyword: "城市马拉松报名", heat: 768000, trend: "up", category: "体育" },
  { keyword: "智能交通系统", heat: 712000, trend: "flat", category: "科技" },
  { keyword: "跨境电商新规", heat: 683000, trend: "down", category: "财经" },
  { keyword: "高效记忆方法", heat: 655000, trend: "up", category: "生活" },
  { keyword: "数字经济趋势", heat: 621000, trend: "flat", category: "财经" },
  { keyword: "秋季电影节", heat: 594000, trend: "up", category: "娱乐" },
  { keyword: "家常菜十分钟学", heat: 572000, trend: "flat", category: "生活" },
  { keyword: "大运河文化", heat: 538000, trend: "down", category: "热点" },
  { keyword: "未来城市展望", heat: 511000, trend: "up", category: "热点" },
  { keyword: "科学健身指南", heat: 486000, trend: "flat", category: "体育" },
  { keyword: "音乐节现场", heat: 452000, trend: "down", category: "娱乐" },
];

export interface SearchSuggestion {
  keyword: string;
  type: "热词" | "相关";
}

export const suggestionBank: SearchSuggestion[] = [
  { keyword: "人工智能大模型", type: "热词" },
  { keyword: "人工智能应用场景", type: "相关" },
  { keyword: "人工智能与教育", type: "相关" },
  { keyword: "新能源汽车补贴", type: "热词" },
  { keyword: "新能源汽车充电桩", type: "相关" },
  { keyword: "新能源汽车排行榜", type: "相关" },
  { keyword: "量子计算入门", type: "热词" },
  { keyword: "量子计算与人工智能", type: "相关" },
  { keyword: "秋冬季旅游推荐", type: "热词" },
  { keyword: "秋冬季穿搭", type: "相关" },
  { keyword: "前三季度经济数据解读", type: "热词" },
  { keyword: "全国运动会赛程", type: "热词" },
  { keyword: "马拉松训练计划", type: "相关" },
  { keyword: "城市马拉松报名时间", type: "相关" },
  { keyword: "全球气候大会成果", type: "热词" },
  { keyword: "气候变化对生活的影响", type: "相关" },
  { keyword: "数字经济与就业", type: "热词" },
  { keyword: "智能交通未来趋势", type: "相关" },
  { keyword: "跨境电商政策", type: "相关" },
  { keyword: "高效学习记忆法", type: "相关" },
  { keyword: "大运河沿线城市", type: "相关" },
  { keyword: "家常菜做法大全", type: "相关" },
  { keyword: "科普视频推荐", type: "相关" },
  { keyword: "百科词条大全", type: "相关" },
];

export const homeHotWords = [
  "人工智能大模型",
  "秋冬季旅游攻略",
  "前三季度经济数据",
  "新能源汽车销量",
  "全国运动会",
  "量子计算原理",
  "城市马拉松报名",
];

export const relatedTagPool = [
  "人工智能",
  "大模型",
  "新能源",
  "汽车",
  "经济",
  "数据",
  "量子计算",
  "科普",
  "马拉松",
  "体育",
  "旅游",
  "生活",
  "科技",
  "百科",
  "气候",
  "能源",
];